// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ElecManagement_wrapper__1OlxR"};